const ANNOUNCEMENTS = 'd34b6946-8345-4080-84c1-67cf122fb4c8';
const SUBSCRIBE = '03e17e8a-f79a-4fe7-88ea-21c9b94ec45d';
export const WidgetIds = {
  ANNOUNCEMENTS,
  SUBSCRIBE
};
//# sourceMappingURL=blocksWidgets.js.map